module.exports = __webpack_public_path__ + "static/media/boing.28da525a.mp3";